import { getLinkMarkup, ILink } from './LinkCell';
import { ContentDraftStatus } from '../../../../ts/ServerApi/types/ContentDraft';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';
import { StyledCellFormatter } from '../StyledCellWrapper';
import { CommonStyles } from '../../../../common/react/CommonStyles';
import _ from 'underscore';
import { DraftTags } from '../../../../drafts/components/DraftTags';
import { DraftTagsParentType } from '../../../../drafts/types/DraftsTypes';

export interface ILinkWithDraftStatus extends ILink {
  draftStatus: ContentDraftStatus;
}

// has the same behavior as LinkCell except for if its a flow with a draft status it will render markers and will
// also create a link that goes straight to the flow editor for drafts with 'UNPUBLISHED' status since they have no place page
// for other content types it will just render the appropiate link, just like LinkCell
export function LinkWithDraftStatus(linkFn: (row: DataGrid.Row) => ILinkWithDraftStatus): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
      React.createFactory(class extends React.Component<BodyCell.Props, any> {
        textEllipsis = CommonStyles.Layout.TextEllipsis;
        leftPadding = {
          marginLeft: CommonStyles.Sizes.DefaultSpace,
          display: 'flex'
        };

        render() {
          const link: ILinkWithDraftStatus = linkFn(this.props.row);
          if (!link) {
            return null;
          }

          let Icon = null;
          if (link.iconClassName || link.iconTitle) {
            Icon = () => <span data-tb-test-id="data-grid-cell-icon"
                               className={link.iconClassName}
                               title={link.hideTooltips ? null : link.iconTitle}
                               style={{flex: 'none'}}/>;
          }

          const shouldShowDraftTags: boolean = (this.props.row.data.contentType === 'flow' || this.props.row.data.contentType === 'workbook')
              && (link.draftStatus === ContentDraftStatus.unpublished || link.draftStatus === ContentDraftStatus.unpublishedchanges);

          return (
              <span data-tb-test-id={link.testId} style={CommonStyles.Layout.FlexBlockLeftAndCenter}>
            {Icon && <Icon/>}
                {link.displayJustText ?
                    <span
                        title={link.hideTooltips ? null : (link.title || link.text)}
                        style={_.extend({display: 'block'}, this.textEllipsis, link.style)}
                    >
                  {link.text}
              </span>
                    : getLinkMarkup(link, this.props.row)
                }
                {shouldShowDraftTags ?
                    <DraftTags
                        draftStatus={link.draftStatus}
                        parentType={DraftTagsParentType.list}
                        explorableItemType={this.props.row.data.contentType}
                    /> :
                    null}
          </span>
          );
        }
      })
  );
}
